// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog--blog--AqtbV","header":"blog--header--23NhZ"};